export default __webpack_public_path__ + "static/media/counterstrike3.bdce1650.png";